export default __webpack_public_path__ + "static/media/boards.fd06cd05.svg";